import axios from 'axios'
import getDevices from '../modules/getDevices'

/**
 * Gets all devices from backend API.
 */
export default function getAllDevices ({ commit, state }) {
  axios.get(`${process.env.VUE_APP_API_URL}api/devices/all`, {
    headers: {
      'x-access-token': localStorage.getItem('user-token')
    }
  })
    .then(function (response) {
      commit('updateDevices', getDevices(response.data.data))
    })
    .catch(function (error) {
      console.log(error)
    })
}
